import { render, staticRenderFns } from "./Pajak.vue?vue&type=template&id=d0616b92&"
import script from "./Pajak.vue?vue&type=script&lang=js&"
export * from "./Pajak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports